/**
 * @generated SignedSource<<0bb9df0962505226e0da3266755e137d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingPayment_Booking$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BookingPaymentMethodSelect_booking" | "BookingReservation_Booking" | "ChargesSummary_booking">;
  readonly " $fragmentType": "BookingPayment_Booking";
};
export type BookingPayment_Booking$key = {
  readonly " $data"?: BookingPayment_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingPayment_Booking">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "patronLoyalty",
    "variableName": "patronLoyalty"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "patronLoyalty"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingPayment_Booking",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "BookingReservation_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingPaymentMethodSelect_booking"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "ChargesSummary_booking"
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "432028e83982a86b6c810499542d59d9";

export default node;
